import gql from 'graphql-tag'
import { GetServerSidePropsContext } from 'next'
import { getClemanClientByServer } from '@/apis/cleman'
import { ClemanClient } from '@forchange/cleman-client'

const graphqlUrl = gql`
  query currentUser {
    currentUser {
      id
      photo
      nickname
      username
      phone
      email
      fanbookUser {
        id
      }
    }
  }
`

export interface ICurrentUser {
  id: string
  photo: string
  nickname: string
  username: string
  phone: string
  email: string
  fanbookUser?: {
    id: string
  }
}

const getCurrentUser = async (client: ClemanClient) => {
  return client.apollo.query<{ currentUser: ICurrentUser }>({
    query: graphqlUrl,
    variables: {},
    fetchPolicy: 'no-cache'
  })
}

export { getCurrentUser }
